import { useSiteSettingsStore } from "../store/siteSettings";

export default defineNuxtPlugin((nuxtApp) => {
    const dataAll = useDataAll()
    const { ENABLE_TRACKING } = useRuntimeConfig();
    const cookie_policy_accepted = useCookie("cookie_policy_accepted", {
        maxAge: 24 * 60 * 60 * 365,
      });
    const accesGranted = cookie_policy_accepted.value==1?true:false;  
    const { gtag, initialize , enableAnalytics, disableAnalytics} = useGtag()
    const siteSettings = useSiteSettingsStore();
    const { $apiMethods } = useNuxtApp()
    const analytics = {
      allConsentGranted(){
            if (siteSettings.TagManagerCode && siteSettings.TagManagerCode.length > 4){
                initialize(siteSettings.TagManagerCode)
                enableAnalytics(siteSettings.TagManagerCode)
                analytics.addGMTToHeader()
            }

            gtag('consent', 'update', {
              'ad_user_data': 'granted',
              'ad_personalization': 'granted',
              'ad_storage': 'granted',
              'analytics_storage': 'granted'
            });
        },
        allConsentRevoked(){
            if (siteSettings.TagManagerCode && siteSettings.TagManagerCode.length > 4 && ENABLE_TRACKING ==1){
                disableAnalytics(siteSettings.TagManagerCode)
                useHead({
                    script: [
                      {
                        hid: "gmt",
                        tagPosition: "", // Lege waarde zorgt ervoor dat Nuxt het verwijdert
                      },
                    ],
                    noscript:[
                      {
                        hid: "gmt-noscript",
                        tagPosition: "", // Lege waarde zorgt ervoor dat Nuxt het verwijdert                      
                      }
                    ]
                  });
                  gtag('consent', 'update', {
                    'ad_user_data': 'denied',
                    'ad_personalization': 'denied',
                    'ad_storage': 'denied',
                    'analytics_storage': 'denied'
                  });                  
            }
        },
        addGMTToHeader(tagManagerCode){
          if (ENABLE_TRACKING ==1){
        
            // if no acces is granted (privacy accepted) disable all google tracking, but load the 
            const GMTDenied = !accesGranted?{
              // add grag with variabled to denied
              innerHTML: `
                window.dataLayer = window.dataLayer || [];
                function gtag() { dataLayer.push(arguments); }
                gtag('consent', 'default', {
                  'ad_storage': 'denied',
                  'analytics_storage': 'denied',
                  'functionality_storage': 'denied',
                  'personalization_storage': 'denied'
                });
              `,
              type: 'text/javascript',
              hid: "gtm_denied"
            }
            :
             // add grag with variabled to granted
            {
              innerHTML: `
                window.dataLayer = window.dataLayer || [];
                function gtag() { dataLayer.push(arguments); }
                gtag('consent', 'default', {
                  'ad_storage': 'granted',
                  'analytics_storage': 'granted',
                  'functionality_storage': 'granted',
                  'personalization_storage': 'granted'
                });
              `,
              type: 'text/javascript',
              tagPriority: -1,
              hid: "gtm_granted"
            }

            useHead({
                script: [
                  GMTDenied,
                  {
                    hid: "gtm",
                    innerHTML: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${tagManagerCode}');`,
                    type: "text/javascript",
                    tagPriority: -1,
                  },
                ],
                noscript: [
                  {
                    hid: "gtm-noscript",
                    innerHTML:
                      '<iframe src="https://www.googletagmanager.com/ns.html?id='+tagManagerCode+'" height="0" width="0" style="display:none;visibility:hidden"></iframe>',
           
                    tagPosition: 'bodyOpen'
                  },
                ],
              });
        }
      }
    }
    

      if (!import.meta.server && accesGranted){
        // initialize analytics
        if (siteSettings.TagManagerCode && siteSettings.TagManagerCode.length > 4 && ENABLE_TRACKING ==1){
          initialize(siteSettings.TagManagerCode)
        }
      }


      nuxtApp.provide('analytics', analytics);
  
});